import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

import { CardDetails } from '../models/card-details';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnInit {
  @Input()
  card: CardDetails;
  @Output()
  clicked = new EventEmitter<CardDetails>();

  public hasAvatarImg: boolean;
  public hasImg: boolean;

  constructor() {}

  ngOnInit(): void {
    this.hasAvatarImg = this.card.avatarImgSrc !== undefined;
    this.hasImg = this.card.imageSrc !== undefined;
    this.card.buttons = this.card.buttons || [];
    this.card.color = this.card.color || '#4c7ea3';
  }

  cardClick(card: CardDetails, buttonData: string): void {
    card.clickedButtonName = buttonData;
    this.clicked.emit(card);
  }
}
